<template>
  <section class="app-main" ref="appMain">
    <transition name="fade-transform" mode="out-in">
        <!-- <keep-alive :include="cachedViews">  -->
          <router-view :key="key" />
        <!-- </keep-alive>  -->
    </transition>
  </section>
</template>

<script>
export default {
  name: "AppMain",
  computed: {
    // cachedViews() {
    //    return this.$store.state.tagsView.cachedViews;
    // },
    key() {
      return this.$route.path;
    }
  },
  mounted() {
    this.$refs.appMain.scrollTop = 0;
  }
};
</script>

<style lang="scss" scoped>
.app-main {
  min-height: calc(65vh - 70px);
}

</style>


